<script lang="ts">
	import { get } from 'svelte/store';
	//Formating
	import { format } from 'svelte-i18n';
	import { Alert, Button } from '@Shelly/shelly-design-system';
	//Helpers
	import { getLoraAddonStatus } from 'src/helpers/addons/addon_lora_helpers';
	import { open_external_link_android } from 'src/services/native_container_requests_android';
	import { open_external_link } from 'src/services/native_container_requests_ios';
	import { real_id } from 'src/helpers/interface_helpers';
	import {
		createPeripheralDevice,
		deletePeripheralDevice,
	} from 'src/helpers/addons/addon_device_helpers';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Stores
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { devices } from 'src/stores/lists/devices';
	import { app, os } from 'src/stores/session/native-bridge';
	//Components
	import PeripheralExtractAsDevice from '../PeripheralExtractAsDevice.svelte';
	import LoRaContainer from './LoRaContainer.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { Peripheral } from 'src/types/Peripherals';
	import type { SettingRequest } from 'src/types/requests/settings/setting';

	export let device: Device;

	const id = device.id;
	const navigateToLocal = () => {
		const url = `http://${ip}/#/addon/manage`;
		//if user isn't host owner prevent navigation because not able to get nothing
		if (typeof ip == 'string' && /\d/gi.test(ip)) {
			if ($app) {
				if ($os === 'IOS') {
					open_external_link(url);
				} else {
					open_external_link_android(url);
				}
			} else {
				window.open(url);
			}
		}
	};

	$: statusStore = getDeviceStatus(id);
	$: ip = $statusStore?.wifi?.sta_ip;

	let loraPeripherals: Peripheral[];
	let peripheralDeviceID: string;
	let extractAsDevice = false;
	let peripheralDevice: Device;
	let waitingForResponse = false;

	$: if ($statusStore) {
		loraPeripherals = getLoraAddonStatus(device);
		if (!peripheralDeviceID) {
			peripheralDeviceID = `${real_id(device.id)}_${100}`;
			peripheralDevice = get(devices)[peripheralDeviceID];
			extractAsDevice = peripheralDevice != null;
		}
	}

	const save = async () => {
		let res: SettingRequest;
		waitingForResponse = true;
		if (extractAsDevice && !peripheralDevice) {
			res = await createPeripheralDevice(device, {
				peripheralType: 'lora',
				icon: 'fas fa-signal-stream',
				settings: {
					name: 'LoRa Add-on',
				},
				sensor: {
					extid: 100,
					type: 'lora',
					component: 'lora:100',
				},
			} as any);
		} else if (!extractAsDevice && peripheralDevice) {
			res = await deletePeripheralDevice(peripheralDevice);
		}
		if (res?.isok) {
			peripheralDeviceID = null;
		}
		onSettingsResponse(res, device);
		waitingForResponse = false;
	};
</script>

<Alert
	type="info"
	class="mb-s"
	heading={$format('alert_heading_lora_components_guide', {
		default:
			"The LoRa Add-on can be managed through the device's Local Web Interface. Use the IP link below if you are on the same network as the device.",
	})}
	cta={{
		title: ip,
	}}
	on:cta_click={navigateToLocal}
/>

{#if loraPeripherals?.length}
	<LoRaContainer {device} statuses={loraPeripherals} />
	<PeripheralExtractAsDevice bind:extractAsDevice />
	<Button
		class="mt-s"
		width="full"
		size="m"
		on:click={save}
		disabled={waitingForResponse ||
			(extractAsDevice && peripheralDevice) ||
			(!extractAsDevice && !peripheralDevice)}
		>{$format('button_save', { default: 'Save' })}</Button
	>
{/if}
